import React, { useState } from 'react';
import t from '@jetshop/intl';
import { styled } from 'linaria/react';
import { Button } from '../ui/Button';
import { ReactComponent as Cross } from '../../svg/Cross.svg';
import { theme } from '../Theme';

const Container = styled('section')`
  width: 100%;
  height: 100%;
  position: relative;

  iframe {
    display: block;
    height: 100%;
    width: 100%;
  }
`;

const CloseModalContainer = styled('div')`
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;

  .close-modal {
    width: 2rem;
    height: 2rem;
    background: #fff;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 0.3rem rgba(0, 0, 0, 0.3);

    svg {
      width: 1rem;
      height: 1rem;
      cursor: pointer;
    }
  }
`;

const ConfirmationContainer = styled('section')`
  position: absolute;
  top: 3rem;
  right: 0;
  padding: 1rem;
  background: #fff;

  p {
    margin-bottom: 1rem;
  }

  div {
    display: flex;

    ${theme.below.sm} {
      flex-direction: column;

      button {
        width: 100%;
        margin: 0.25rem 0 !important;
      }
    }

    button + button {
      margin-left: 1rem;
    }
  }
`;

const CloseModal = ({ hideTarget }) => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  return (
    <CloseModalContainer>
      <span
        className="close-modal"
        onClick={() => {
          setIsConfirmationOpen(!isConfirmationOpen);
        }}
      >
        <Cross />
      </span>
      {isConfirmationOpen && (
        <ConfirmationContainer>
          <p>{t('Are you sure you want to close the configurator?')}</p>
          <div>
            <Button
              className="cancel"
              onClick={() => {
                setIsConfirmationOpen(false);
              }}
            >
              {t('Cancel')}
            </Button>
            <Button className="close" onClick={hideTarget}>
              {t('Close the configurator')}
            </Button>
          </div>
        </ConfirmationContainer>
      )}
    </CloseModalContainer>
  );
};

const Configurator = ({ hideTarget }) => {
  return (
    <Container>
      <CloseModal hideTarget={hideTarget} />
      <iframe
        title={'Konfigurator'}
        src="https://hammel.3dconfig.dk/tool/?dealer=mobelmastarna"
        frameBorder="0"
      ></iframe>
    </Container>
  );
};
export default Configurator;
